import React from 'react';
import ThemeItem from './ThemeItem'

class ThemeFilter extends React.Component {
  renderSelectAllLabel() {
    if (this.props.allItemsNotSelected()) {
      return (
        <span className='all-items' onClick={this.props.selectAllItems}>
          Select All
        </span>
      )
    }
  }

  renderThemeItem(theme, i) {
    return (
      <ThemeItem
        key={i}
        theme={theme}
        handleFilterChange={this.props.handleFilterChange}
        checked_themes={this.props.themes}
      />
    )
  }

  render() {
    return (
      <div className='themes-filter'>
        <div className='all-benefits'>
          <span> Benefit Themes </span>
          { this.renderSelectAllLabel() }
        </div>
        { this.props.data.map((theme, i) => this.renderThemeItem(theme, i)) }
      </div>
    )
  }
}

export default  ThemeFilter